import React, { useState } from 'react';
import styled from 'styled-components';
import { Button, ButtonGroup } from './FormElements';
import { sgfService } from '../services/api';

const FormContainer = styled.div`
  width: 100%;
`;

const Title = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
  color: ${props => props.theme.colors.text};
  text-align: center;
`;

const Subtitle = styled.p`
  font-size: 0.95rem;
  margin-bottom: 2rem;
  color: ${props => props.theme.colors.lightText};
  text-align: center;
`;

const PlanCard = styled.div`
  background: ${props => props.theme.colors.lightBackground};
  border: 2px solid ${props => props.theme.colors.border};
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const PlanHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid ${props => props.theme.colors.border};
`;

const PlanType = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: ${props => props.theme.colors.text};
  margin-bottom: 1.5rem;
`;

const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
`;

const PriceItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  background: rgba(255, 127, 0, 0.08);
  border-radius: 8px;
  width: 100%;
`;

const PriceLabel = styled.div`
  font-size: 0.9rem;
  color: ${props => props.theme.colors.lightText};
  margin-bottom: 0.5rem;
  font-weight: 500;
`;

const PriceValue = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  color: ${props => props.theme.colors.primary};
`;

const PriceDetail = styled.div`
  font-size: 0.85rem;
  color: ${props => props.theme.colors.lightText};
  margin-top: 0.25rem;
`;

const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const BenefitItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 0.9rem;
  color: ${props => props.theme.colors.text};
  line-height: 1.5;

  &:before {
    content: "✓";
    color: ${props => props.theme.colors.primary};
    font-weight: bold;
    font-size: 1.1rem;
    flex-shrink: 0;
  }
`;

const InfoBox = styled.div`
  background: rgba(255, 127, 0, 0.08);
  border: 1px solid rgba(255, 127, 0, 0.3);
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: ${props => props.theme.colors.text};
  line-height: 1.6;
`;

const EstablishedCompanyPlanScreen = ({ formData, updateFormData, nextStep, prevStep }) => {
  const [toastMessage, setToastMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const planDescription = 'Plano Contribuição Sindical - Taxa de filiação R$150, Mensalidade R$150';
      const observacoes = `${formData.observacoes || ''}`.trim()
        ? `${formData.observacoes}\n${planDescription}`
        : planDescription;

      await sgfService.sendFiliada({ ...formData, observacoes });

      setToastMessage('Cadastro enviado com sucesso');
      setTimeout(() => setToastMessage(''), 3000);

      updateFormData({ selected_plan: 'established' });
      nextStep();

    } catch (error) {
      console.error('Erro ao enviar filiada ao SGF:', error);
      alert(`Erro ao enviar cadastro: ${error.message}`);
    }
  };

  const benefits = [
    'Plano anual com pagamentos mensais',
    'Todos os benefícios exclusivos',
    'Acesso a empresários experientes',
    'Representação institucional',
    'Participação no Jantar Empresarial EPTEC durante o GoRN',
    'Participação no jantar de confraternização de final de ano'
  ];

  return (
    <FormContainer>
      {/* Toast simples no canto superior direito */}
      {toastMessage && (
        <div style={{ position: 'fixed', top: 20, right: 20, background: '#10b981', color: 'white', padding: '10px 14px', borderRadius: 8, boxShadow: '0 8px 20px rgba(0,0,0,0.12)', zIndex: 9999 }}>
          {toastMessage}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <Title>Filiação Empresas Estabelecidas</Title>
        <Subtitle>Plano para empresas já consolidadas no mercado</Subtitle>

        <PlanCard>
          <PlanHeader>
            <PlanType>Plano Contribuição Sindical</PlanType>
            
            <PriceSection>
              <PriceItem>
                <PriceLabel>Taxa de Filiação (única vez)</PriceLabel>
                <PriceValue>R$ 150,00</PriceValue>
                <PriceDetail>Vencimento em até 3 dias após cadastro</PriceDetail>
              </PriceItem>

              <PriceItem>
                <PriceLabel>Mensalidade</PriceLabel>
                <PriceValue>R$ 150,00</PriceValue>
                <PriceDetail>Vencimento todo dia 20 de cada mês</PriceDetail>
              </PriceItem>
            </PriceSection>
          </PlanHeader>

          <BenefitsList>
            {benefits.map((benefit, index) => (
              <BenefitItem key={index}>{benefit}</BenefitItem>
            ))}
          </BenefitsList>

          <InfoBox>
            💡 <strong>Informação importante:</strong> A taxa de filiação é cobrada apenas uma vez no momento do cadastro. 
            A mensalidade de R$ 150,00 será cobrada mensalmente a partir do mês seguinte ao cadastro.
          </InfoBox>
        </PlanCard>

        <ButtonGroup>
          <Button type="button" onClick={prevStep}>Voltar</Button>
          <Button type="submit" primary>
            Continuar com este plano
          </Button>
        </ButtonGroup>
      </form>
    </FormContainer>
  );
};

export default EstablishedCompanyPlanScreen;
